import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { REQUEST_UPDATE_MASTER_PROMOCODE } from "../../store/promoCode/promoCodeActionTypes";
import { usePromoCodeMaster } from "../../store/promoCode/reducer";
interface Props {
  promocode: Record<string, any>;
  isOpen: any;
  onClose: any;
}
const PromoCodeDeactiveConfirmation: React.FC<Props> = ({
  promocode,
  isOpen,
  onClose,
}) => {
  const dispatch = useDispatch();
  const { masterPromoCode, busy, message } = usePromoCodeMaster()

  const { _id, active } = promocode;

  useEffect(() => {
    const findLink = masterPromoCode.find((val: Record<string, any>) => val._id === _id);
    if (findLink.active !== active) {
      onClose();
    }
  }, [_id, masterPromoCode, onClose, active]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Link</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            {promocode.active
              ? "You are going to Hide this PromoCode? "
              : "You are going to Show this PromoCode? "}
            {promocode.promotionCode}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              const data = { _id: promocode._id, payload: { active: !promocode.active } }
              dispatch({
                type: REQUEST_UPDATE_MASTER_PROMOCODE,
                data,
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};
export default PromoCodeDeactiveConfirmation;
